module.exports = __webpack_public_path__ + "static/media/SF_bm_sekundaerlogo_postale_moere_og_romsdal_pos.87bc8f6e.svg";